module.exports = __webpack_public_path__ + "static/media/icon-moduleA3.6593e1f0.png";